export interface ErrorResponse {
  status: number;
  error: string;
  message: string;
  details?: string;
  path: string;
  timestamp: string;
  validationErrors?: ValidationError[];
  metadata?: any;
}

export interface ValidationError {
  field: string;
  rejectedValue: any;
  message: string;
}

export interface ErrorNotification {
  id: string;
  type: 'error' | 'warning' | 'info' | 'success';
  title: string;
  message: string;
  details?: string;
  timestamp: Date;
  autoClose?: boolean;
  duration?: number;
}

export enum ErrorCode {
  BAD_REQUEST = 'BAD_REQUEST',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  BINDING_ERROR = 'BINDING_ERROR',
  CONSTRAINT_VIOLATION = 'CONSTRAINT_VIOLATION',
  MISSING_PARAMETER = 'MISSING_PARAMETER',
  TYPE_MISMATCH = 'TYPE_MISMATCH',
  MALFORMED_REQUEST = 'MALFORMED_REQUEST',
  INVALID_ARGUMENT = 'INVALID_ARGUMENT',
  INVALID_SEARCH = 'INVALID_SEARCH',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  TIMEOUT_ERROR = 'TIMEOUT_ERROR'
}

export enum ErrorSeverity {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

export interface ErrorContext {
  component?: string;
  action?: string;
  userId?: string;
  sessionId?: string;
  url?: string;
  userAgent?: string;
  timestamp?: Date;
}
